// Shared alert-tone catalogue. Kept in sync with the WebAudio synth in
// EventNotificationBell.jsx's playAlertTone() — every id here must map to a case there.
export const ALERT_TONES = [
  { id: 'default', label: 'Default Beep', freq: 800, duration: 200 },
  { id: 'alarm', label: 'Alarm', freq: 1200, duration: 400 },
  { id: 'chime', label: 'Chime', freq: 600, duration: 150 },
  { id: 'urgent_siren', label: 'Urgent Siren', freq: 900, duration: 600 },
  { id: 'triple_beep', label: 'Triple Beep', freq: 1000, duration: 150 },
  { id: 'continuous', label: 'Continuous Alarm', freq: 1100, duration: 300 },
  { id: 'low_warning', label: 'Low Warning', freq: 350, duration: 500 },
  { id: 'none', label: 'No Sound', freq: 0, duration: 0 },
];

export const ALERT_DURATIONS = [
  { id: 'once', label: 'Once' },
  { id: '3s', label: '3 seconds' },
  { id: '5s', label: '5 seconds' },
  { id: '10s', label: '10 seconds' },
  { id: 'until_dismissed', label: 'Until dismissed' },
];
